import React from 'react';

export const LazyPostConversation = React.lazy(() =>
  import('./PostConversation').then((module) => ({
    default: module.PostConversation,
  }))
);
